var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

export function scalarToColor(scalar, colorMap, colorMapRange) {
  // console.log("SCALAR TO COLOR", scalar, colorMap, colorMapRange);
  var indexFloat = (colorMap.length - 1) * (scalar - colorMapRange[0]) / (colorMapRange[1] - colorMapRange[0]);

  if (indexFloat <= 0) {
    return colorMap[0];
  } else if (indexFloat >= colorMap.length - 1) {
    return colorMap[colorMap.length - 1];
  }

  var index = Math.floor(indexFloat);
  var delta = indexFloat - index;
  var color = [(1 - delta) * colorMap[index][0] + delta * colorMap[index + 1][0], (1 - delta) * colorMap[index][1] + delta * colorMap[index + 1][1], (1 - delta) * colorMap[index][2] + delta * colorMap[index + 1][2]];
  return color;
} // const lineColors: [number, number, number][] = [
// [1, 0, 0],
// [0, 1, 0],
// [0, 0, 1]
// ]

export function getLineColor() {
  var i, idx;
  return __generator(this, function (_a) {
    switch (_a.label) {
      case 0:
        i = 0;
        _a.label = 1;

      case 1:
        if (!true) return [3
        /*break*/
        , 3];
        idx = i % viridis.length;
        return [4
        /*yield*/
        , viridis[idx]];

      case 2:
        _a.sent();

        i += 4;
        return [3
        /*break*/
        , 1];

      case 3:
        return [2
        /*return*/
        ];
    }
  });
}
export function rgbToHex(r, g, b) {
  var red = numToHex(Math.floor(r * 255));
  var green = numToHex(Math.floor(g * 255));
  var blue = numToHex(Math.floor(b * 255));
  return red + green + blue;
}
;

function numToHex(n) {
  var hex = Number(n).toString(16);

  if (hex.length < 2) {
    hex = "0" + hex;
  }

  return hex;
}

;
export var viridis = [[0.267004, 0.004874, 0.329415], [0.282327, 0.094955, 0.417331], [0.278826, 0.17549, 0.483397], [0.258965, 0.251537, 0.524736], [0.229739, 0.322361, 0.545706], [0.19943, 0.387607, 0.554642], [0.172719, 0.448791, 0.557885], [0.149039, 0.508051, 0.55725], [0.127568, 0.566949, 0.550556], [0.120638, 0.625828, 0.533488], [0.157851, 0.683765, 0.501686], [0.24607, 0.73891, 0.452024], [0.369214, 0.788888, 0.382914], [0.515992, 0.831158, 0.294279], [0.678489, 0.863742, 0.189503], [0.845561, 0.887322, 0.099702], [0.993248, 0.906157, 0.143936]];
export var plasma = [[0.050383, 0.029803, 0.527975], [0.193374, 0.018354, 0.59033], [0.299855, 0.009561, 0.631624], [0.399411, 0.000859, 0.656133], [0.494877, 0.01199, 0.657865], [0.584391, 0.068579, 0.632812], [0.665129, 0.138566, 0.585582], [0.736019, 0.209439, 0.527908], [0.798216, 0.280197, 0.469538], [0.853319, 0.351553, 0.413734], [0.901807, 0.425087, 0.359688], [0.942598, 0.502639, 0.305816], [0.973416, 0.585761, 0.25154], [0.991365, 0.675355, 0.198453], [0.993033, 0.77172, 0.154808], [0.974443, 0.874622, 0.144061], [0.940015, 0.975158, 0.131326]];
export var redWhiteBlue = [[1, 0, 0], [1, 1, 1], [0, 0, 1]];
export var blackWhite = [[0, 0, 0], [1, 1, 1]];